






































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import axios from 'axios';
import { api } from '@/api';
import { MediaResource } from '@/interfaces/Models';
import FamilyReportForm from '@/components/dashboard/shared/components/FamilyReportForm.vue';
import SessionArchiveDetails from '@/components/dashboard/shared/components/Session/SessionArchiveDetails.vue';

@Component({
    components: {
        FamilyReportForm,
        SessionArchiveDetails,
    }
})
export default class SessionArchiveTable extends Vue {

    public sessions: any[] = [];
    public archiveLoading: boolean = false;

    public selectedSession: any | null = null;
    public selectedSessionIndex: any = null;

    public pagination = {
        page: 1,
        itemsPerPage: 10,
        lastPage: 1,
    }

    public totalItems: number = 10;

    public familyReportFormDialog: boolean = false;

    public get sessionReport() {
        return this.selectedSession?.report;
    }

    public sessionArchiveDialog: boolean = false
    
    public loadArchive() {

        this.archiveLoading = true;

        let params = {
            page: this.pagination.page
        }

        axios.get(api.path('v1.b.sessions'), { params: params })
            .then(res => {
                this.sessions = res.data.data;
                this.pagination.page = res.data.meta.current_page;
                this.pagination.lastPage = res.data.meta.last_page;
            })
            .finally(() => this.archiveLoading = false);
    }

    @Watch('pagination.page', { deep: true })
    onPaginationChange( page: number ) {
        this.selectedSessionIndex = null;
        this.loadArchive();
    }
    
    @Watch('selectedSessionIndex')
    onSelectChange( item: any ) {
        if ( item != null )  {
            this.selectedSession = this.sessions[item];
            this.sessionArchiveDialog = true;
            
        } else {
            this.selectedSession = null;
            this.sessionArchiveDialog = false;
        }
        
    }

    public showFamilyReportForm() {
        this.familyReportFormDialog = true;
    }

    public mounted() {
        this.loadArchive();
    }
}
